import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { BlogPage } from '@/pages/BlogPage';
import { BlogPostPage } from '@/pages/BlogPostPage';
import { AdminLoginPage } from '@/pages/AdminLoginPage';
import { AdminDashboardPage } from '@/pages/AdminDashboardPage';
import { PostEditorPage } from '@/pages/PostEditorPage';
import { Traveling } from '@/pages/Traveling';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { MyBrainPage } from '@/pages/MyBrainPage';
import { Layout } from '@/components/Layout';
import { ThemeProvider } from '@/components/theme-provider';
import { ChatProvider } from '@/contexts/ChatContext';

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="blog-theme">
      <ChatProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/traveling" element={<Traveling />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/my-brain" element={<MyBrainPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
              <Route path="/admin/posts/new" element={<PostEditorPage />} />
              <Route path="/admin/posts/:id/edit" element={<PostEditorPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ChatProvider>
    </ThemeProvider>
  );
}

export default App;